import type { infer as zInfer } from "zod/v4";
import * as z from "zod/v4";

export const getShopifyIntegration = {
  name: "getShopifyIntegration" as const,
  input: z.object({}),
  output: z.union([
    z.object({ skipRefunds: z.boolean(), enabled: z.boolean().nullish() }),
    z.undefined(),
  ]),
};

export type ShopifyIntegration = zInfer<typeof getShopifyIntegration.output>;
